import { CloseCircleFill } from '@olist/design-system-icons';
import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import Button from '../Button/Button.js';
import '../Input/Input.js';
import { InputBody } from '../Input/InputBody.js';
import 'react';
import '../Input/InputPassword/styles.js';
import { WrapperInput } from '../Input/styles.js';

const StyledInput = styled(InputBody) `
  width: 100%;

  &::-webkit-search-cancel-button {
    appearance: none;
  }
`;
const SearchCancelButton = styled.button(({ theme: { olist: { color }, }, }) => css `
    display: none;
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: ${color.neutral.strong};

    &:hover {
      color: ${color.neutral.stronger};
    }
  `);
const SearchCancelIcon = styled(CloseCircleFill) `
  width: 16px;
  height: 16px;
`;
const Wrapper = styled.div(({ hasCtaButton }) => css `
    width: 100%;

    &:focus-within {
      ${SearchCancelButton} {
        display: block;
      }
    }

    ${hasCtaButton &&
    css `
      ${WrapperInput} {
        padding-right: 0;
      }
    `}

    ${margins}
  `);
const CtaButton = styled(Button)(({ theme: { olist: { spacing }, }, }) => css `
    flex-shrink: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 48px;
    margin-left: ${spacing.inline.small};
  `);

export { CtaButton, SearchCancelButton, SearchCancelIcon, StyledInput, Wrapper };
